import http from '@/plugins/http';

export default (studentId) => new Promise((res, rej) => {
  http.get(`v3/soft_skills/by_student_last_job?student_id=${studentId}`)
    .then((response) => {
      const results = response.data;
      res(results);
    })
    .catch((error) => {
      rej(error);
    });
});
